<div class="tab-pane fade show active" id="day1" role="tabpanel" aria-labelledby="home-tab">
    <FlashMessage></FlashMessage>
    <div class="container-fluid">
        <div class="content-block">
            <div class="error-list" v-if="ui.error.errors">
                <ul class="error-msg">
                    <li v-for="(error,x) in ui.error.errors" :key="x">
                        <div v-for="(err,i) in error" :key="i">
                            <p> {{err}}</p>
                        </div>
                    </li>
                </ul>
            </div>
            <form>
                <div class="form-modified">
                    <div class="row">
                        <div class="col-lg-10 offset-2">
                            <div class="informative-block">
                                <p>
                                    You can add, edit, or delete the generic information of the package such as the title, destination, altitude, and difficulty, etc.

                                </p>
                                <span @click="hideIcon">×</span>
                            </div>
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="inputPassword" class="col-sm-2 col-form-label">Property Type <span
                class="required">*</span></label>
                        <div class="col-sm-10">
                            <label v-if="!status.Edit" for="staticEmail" class="readonly"><span
                  v-if="item.generalList.property_type">{{item.generalList.property_type.name}}</span></label>
                            <div class="multiselect-input" v-if="item.propertyType">
                                <multiselect v-if="status.Edit" :options='item.propertyType' v-model="item.generalList.property_type" label="name" :track-by="'name'" placeholder="Choose Tour Type.." :class="{ 'error-input' : ui.error.validationErrors['property_type_id'] }"></multiselect>
                                <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'property_type_id'" />
                            </div>

                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticTitle" class="col-sm-2 col-form-label">Enter Hotel Name <span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div v-if="!status.Edit">
                                <label v-if="item.generalList.title" for="staticEmail" class="readonly">{{item.generalList.title}}</label>
                            </div>
                            <div v-if="status.Edit">
                                <input type="text" v-if="item.generalList.title" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['title'] }" id="inputPassword" v-model="item.generalList.title" placeholder="Destination name" />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'title'" />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticHotelStar" class="col-sm-2 col-form-label">Star rating</label>
                        <div class="col-sm-10">
                            <div v-if="!status.Edit">
                                <label for="staticEmai1l" class="readonly">{{item.generalList.hotel_star}}</label>
                            </div>
                            <div v-if="status.Edit">
                                <input type="number" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['hotel_star'] }" id="inputPassword1" v-model="item.generalList.hotel_star" placeholder="eg 3 star hotel" min="1" max="5" />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'hotel_star'" />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticPhone" class="col-sm-2 col-form-label">Contact<span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div v-if="!status.Edit">
                                <label v-if="item.generalList.phone" for="staticPhone" class="readonly">{{item.generalList.phone}}</label>
                            </div>
                            <div v-if="status.Edit">
                                <input type="text" v-if="item.generalList.phone" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['phone'] }" id="inputPhone" v-model="item.generalList.phone" placeholder="Contact Number" />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'phone'" />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticAddress" class="col-sm-2 col-form-label">Address<span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div v-if="!status.Edit">
                                <label v-if="item.generalList.address" for="staticAddress" class="readonly">{{item.generalList.address}}</label>
                            </div>
                            <div v-if="status.Edit">
                                <input type="text" v-if="item.generalList.address" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['address'] }" id="inputAddress" v-model="item.generalList.address" placeholder="Address" />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'address'" />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Enter Email <span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div v-if="!status.Edit">
                                <label v-if="item.generalList.title" for="staticEmail" class="readonly">{{item.generalList.email}}</label>
                            </div>
                            <div v-if="status.Edit">
                                <input type="text" v-if="item.generalList.title" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['title'] }" id="inputPassword" v-model="item.generalList.email" placeholder="contact email" />
                            </div>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'email'" />
                        </div>
                    </div>

                    <div class="form-group row">
                        <label for="staticEmail" class="col-sm-2 col-form-label">Pet allowed<span class="required">*</span></label>
                        <div class="col-sm-10">
                            <div v-if="!status.Edit">
                                <label v-if="item.generalList.is_pet_allow==1" class="readonly">Yes</label>
                                <label v-if="item.generalList.is_pet_allow==0" class="readonly">No</label>
                            </div>
                            <div v-if="status.Edit">
                                <label class="customcheck">{{ item.generalList.is_pet_allow==1?'Yes':'No' }}
                                    <input type="checkbox" name="is_pet_allow" value="1" class="destination" v-model="item.generalList.is_pet_allow"/>
                                         <span class="checkmark"></span>
                                       </label> </div>
                        </div>
                    </div>



                    <div class="form-group row">
                        <label for="staticIntro" class="col-sm-2 col-form-label">Enter Description <span
                class="required">*</span></label>
                        <div class="col-sm-10">
                            <label v-if="!status.Edit" for="staticIntro" class="readonly">{{item.generalList.intro_text}}</label>
                            <textarea v-if="status.Edit" name="editor" cols="50" rows="4" class="form-control" :class="{ 'error-input' : ui.error.validationErrors['intro_text'] }" v-model="item.generalList.intro_text"></textarea>
                            <validation-error v-if="ui.error.hasError" :isError="ui.error.hasError" :errors="ui.error.validationErrors" :field="'intro_text'" />
                        </div>
                    </div>


                    <div class="content-block">
                        <div class="row">
                            <div class="col-md-10 offset-md-2">
                                <button v-if="status.Edit" :disabled="ui.status.postLoading.generalList" class="btn default-btn save-btn" type="submit" @click.prevent="setGeneral">
                  {{buttonName}}
                  <spinner v-if="ui.PostLoading" :loading="ui.PostLoading"></spinner>
                </button>
                                <button v-if="status.Edit" class="btn default-btn cancel" type="submit" @click.prevent="cancelGeneralEdit">
                  Cancel
                </button>
                                <button v-if="!status.Edit" class="btn default-btn" type="submit" @click.prevent="editGeneral">
                  Edit
                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>